const en = {
  general: {
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    error: "Error",
    success: "Success",
    next: "Next",
    previous: "Previous",
    submit: "Submit",
    hours: "Hours",
    loading: "Loading",
    coupon: "Coupon",
    couponCode: "Coupon Code",
    apply: "Apply",
    reset: "Reset",
    exam: "Exam",
    exams: "Exams",
    duration: "Duration",
    myDashboard: "My Dashboard",
    pendingRequests: "Pending Requests",
    scheduledExams: "Scheduled Exams",
    globalView: "Global View",
    learners: "Learners",
    settings: "Settings",
    application: "Application",
    download: "Download",
    camera: "Camera",
    approved: "Approved",
    rejected: "Rejected",
    approve: "Approve",
    reject: "Reject",
    banned: "Banned",
    completed: "Completed",
    pending: "Pending",
    deleted: "Deleted",
    username: "Username",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    birthDate: "Birth Date",
    learningInstitution: "Learning Institution",
    learningInstitutions: "Learning Institutions",
    status: "Status",
    error: "Error",
    actions: "Actions",
    search: "Search",
    close: "Close",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    time: "Time",
    no: "No",
    yes: "Yes",
    edit: "Edit",
    delete: "Delete",
    online: "Online",
    name: "Name",
    deactivate: "Deactivate",
    activate: "Activate",
    view: "View",
    date: "Date",
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    dateAndTime: "Date & Time",
    year: "Year",
    softBooted: "Soft Booted",
    flagged: "Flagged",
    confirm: "Confirm",
    back: "Back",
    accept: "Accept",
    decline: "Decline",
    activate: "Activate",
    deactivate: "Deactivate",
    examName: "Exam Name",
    eventLog: "Event Log",
    scheduling: "Scheduling",
    scheduledExams: "Scheduled Exams",
    enter: "Enter",
    total: "Total",
    missingFieldsErrorMessage: "Fill out all highlighted fields",
    all: "All",
    title: "Title",
    active: "Active",
    deactivated: "Deactivated",
    language: "Language",
    formattedPrice: "${{ price }}",
    edit: "Edit",
    limit: "How Many Times Can a Student Book?",
    limitNotice: "Limit Notice",
    note: "Note:",
    nextBooking: "Next Available Booking Time:",
    book: "Book",
    cancelled: "Cancelled",
    request: "Request",
    province: "Province",
    type: "Type",
    once: "Once",
    recurring: "Recurring",
  },
  App: {
    dashboard: "My Dashboard",
    accountDetails: "Account Details",
    downloadApplication: "Download Application",
    logout: "Logout",
    loggingOut: "Logging out...",
    accessDenied: "Access Denied",
  },
  AccountDetails: {
    header: "Account Details",
    whyWeNeedInfo: "Why we need your information",
    dataCollectionExplanation: "We collect your personal information to verify your identity during proctored exams, ensure exam integrity, prevent fraud, and provide you with a secure testing experience. Your headshot is required for identity verification, while your name, date of birth, and address help us confirm your identity. Your timezone and learning institution information ensure you're scheduled correctly and connected to the right exams. All information is stored securely and used only for exam administration and verification purposes. For more information, please see our",
    timezone: "Time Zone",
    selectTimezone: "Select Timezone",
    learningInstitution: "Learning Institution",
    selectLearningInstitution: "Select Learning Institution",
    province: "Province",
    selectProvince: "Select Province",
    dateOfBirth: "Date of Birth",
    streetAddress: "Street Address",
    city: "City",
    postalCode: "Postal Code",
    personalHeadshot: "Personal Headshot",
    headshotPurpose: "Why we need your photo",
    headshotExplanation: "Your headshot is required for identity verification during proctored exams to ensure exam integrity and prevent fraud. Your photo is stored securely and only used for exam verification purposes. For more information, please see our",
    privacyPolicy: "Privacy Policy",
    addPersonalHeadshot: "Please Add a Personal Headshot Before Continuing.",
    completeProfileRequired: "Please complete your account details (photo and learning institution) before continuing.",
    saveAccountDetails: "Save Account Details",
    backToDashboard: "Go to Dashboard",
    error: "Error",
    success: "Success",
    invalidBirthdayFormat: "Invalid birthday format. Please use YYYY-MM-DD format.",
    updatingError: "An Error occurred when updating account details.",
    updatingSuccess: "Your account has been updated.",
    PST: "Pacific Time — observes Daylight Saving Time",
    MST: "Mountain Time — observes Daylight Saving Time",
    CST: "Central Time — observes Daylight Saving Time",
    EST: "Eastern Time — observes Daylight Saving Time",
    AST: "Atlantic Time — observes Daylight Saving Time",
    NST: "Newfoundland Time — observes Daylight Saving Time",
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland and Labrador",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon",
  },
  ExamDetails: {
    header: "Book Exam",
    examName: "Exam Name",
    examPrice: "Exam Price",
    examDetails: "Exam Details",
    duration: "Exam Duration: {{duration}} hours",
    price: "Price",
    description: "Description",
    notes: "Notes",
    tax: "Tax",
    discount: "Discount",
    datePending: "Date (pending): ",
    creditCardNumber: "Credit Card Number",
    creditCardExpiration: "Credit Card Expiration",
  },
  SelectExam: {
    pageTitle: "Select Exam",
    header: "Book Exam",
    selectTrainingProvider: "Please Select a Training Provider",
    selectExamProvider: "Please Select an Exam Provider",
    selectExam: "Please Select an Exam",
    selectProvince: "Please Select a Province",
    selectType: "Please Select an Exam Type",
  },
  ConfirmBooking: {
    reviewConfirm: "Review & Confirm",
    provinceMustBeSet:
      "Province must be set in Account Details in order to process order",
    confirmOrder: "Confirm Order",
    confirming: "Confirming...",
    pendingApproval: "eProctor Booking Request - Pending Approval",
    bookingError: "Unable to process your order.",
    maxCapacity: "Exam has reached max booking capacity.",
    unableBookTime: "Unable to book for specified time",
    dayBlocked: "Unable to book for specified day",
    noFilesUploaded: "No files uploaded.",
  },
  SelectDates: {
    pageTitle: "Select Date & Time",
    time: "Time",
    selectDate: "Please Select Date",
    fullyBooked: "Fully Booked",
    defaultTimes: [
      "9:00 AM",
      "10:00 AM",
      "11:00 AM",
      "12:00 PM",
      "1:00 PM",
      "2:00 PM",
      "3:00 PM",
    ],
  },
  PaymentDetails: {
    couponNotValidForExam: "Coupon not Valid for Exam",
    couponDoesNotExist: "Coupon Does not Exist",
    couponExpired: "Coupon Expired",
    pageTitle: "Payment Details",
    header: "Payment Details",
    fileTooLargeError: "File must be 5MB or less.",
    invalidFileTypeError: "File must be of type jpeg or png",
    couponError: "Coupon Error",
    couponApplied: "Coupon Applied",
    couponAppliedMessage: "Coupon has been applied successfully.",
    expMonth: "Expiration - Month",
    expYear: "Expiration - Year (2 Digits)",
    ccv: "Credit Card CVV2",
  },
  Receipt: {
    pageTitle: "Receipt",
    header: "Book Exam - Request Submitted",
    confirmEligibilityMessage: `Thank you for scheduling your exam with eProctor Canada. Your exam request has been received and will be reviewed within 2 business days. You will receive a confirmation email once your exam has been approved, at which time the payment below will be processed.`,
    downloadEproctorClientMessage: `On the day of your exam, download the eProctor application at least 30 minutes before your scheduled start time. Check-in opens 30 minutes prior to your exam - log in and select your exam to begin the check-in process. A proctor will join you shortly and provide instructions. Once check-in is complete, you will be instructed to begin your exam.`,
    questionsMessage: `If you have any questions or need to make changes to this request, please contact support@eproctorcanada.com`,
    bookingDetails: "Booking Details",
    orderDetails: "Order Details",
  },
  BookExam: {
    step1Label: "Select Exam",
    step2Label: "Select Date & Time",
    step3Label: "Payment Details",
    step4Label: "Review and Confirm Booking",
    step5Label: "Confirmation",
    stepOf: "Step {{current}} of {{total}}",
  },
  Dashboard: {
    scheduledAdminLabel: "View current and future scheduled Exams",
    pendingRequestsAdminlabel: "Review and approve pending Exam requests",
    examsAdminLabel: "View, Add, and Edit exams for Learners to take",
    learnersAdminLabel: "Review learner details",
    scheduleExams: "Schedule Exams",
    rescheduleAdminLabel: "Reschedule and Remove learner exams.",
    settingsAdminLabel: "View and Edit settings for this Learning Institution",
  },
  StudentDashboard: {
    headshotRequired: "Profile Photo Required",
    headshotMessage: "Please upload a personal headshot before booking exams. You can upload your photo on the",
    accountDetailsLink: "Account Details page",
  },
  EmailVerified: {
    success: "Your email has been verified",
  },
  ScheduledExams: {
    header: "Scheduled Exams",
    welcome: "Welcome",
    downloadApplication: "Download Application",
    bookExam: "Book an Exam",
    nextExam: "Next Scheduled Exam",
    quickGuide: "Quick Guide",
    step1: "Download the application on the day of your exam and ensure it is installed at least 30 minutes before your scheduled start time.",
    step2: "Check-in opens 30 minutes prior to your exam. Log in and select your exam to begin the check-in process.",
    step3: "A proctor will join you shortly. Please follow their instructions during check-in.",
    step4: "Begin your exam once check-in is complete and you are instructed to proceed.",
    important: "Important",
    latestVersionNote: "Ensure you have the latest version of the eProctor application to avoid technical difficulties.",
    startExam: "Ready to Start",
    upcomingExams: "Upcoming Exams",
    noExams: "No Scheduled Exams",
    cancelBooking: "Cancel Exam",
    confirmCancelMore24: "Are you sure you want to cancel this exam? Because you are canceling more than 24 hours before the start time, there is no fee and you will receive a full refund (if payment was made). Click Confirm to proceed with the cancellation.",
    confirmCancelLess24: "Are you sure you want to cancel this exam? This cancellation is occurring within 24 hours of your scheduled start time. No refund will be issued. Click Confirm to continue.",
    confirmButton: "Confirm",
    cancelSuccess: "Booking cancelled successfully",
    refundIssued: "A full refund will be processed within 5-10 business days and will appear on the original payment method used for this booking.",
    noRefund: "No refund will be issued due to cancellation within 24 hours.",
    noChargeMade: "No payment was ever collected for this booking, so there's nothing to refund. Any card hold has been released.",
    cancelError: "Failed to cancel booking. Please try again.",
    cancelErrorTitle: "Error",
    cancelErrorCheckedIn: "Cannot cancel booking after checking in or connecting to eProctor.",
    cancelErrorFinalState: "Cannot cancel booking that is already completed, rejected, banned, or cancelled.",
    cancelErrorNotAllowed: "This institution does not allow cancellations for this exam.",
    rescheduleExam: "Reschedule Exam",
    rescheduleSuccess: "Exam rescheduled successfully",
    rescheduleError: "Failed to reschedule booking. Please try again.",
    rescheduleErrorTitle: "Error",
    rescheduleErrorCheckedIn: "Cannot reschedule booking after checking in or connecting to eProctor.",
    rescheduleErrorFinalState: "Cannot reschedule booking that is already completed, rejected, banned, or cancelled.",
    rescheduleErrorNotAllowed: "This institution does not allow rescheduling for this exam.",
    rescheduleErrorUnavailable: "Unable to reschedule booking. The selected time may not be available.",
    rescheduleErrorWithin24Hours: "Cannot reschedule booking within 24 hours of the exam start time.",
    requiresReapproval: "Your booking status has been changed to pending and will require re-approval.",
  },
  GlobalView: {
    room: "Room",
    students: "Students",
    proctor: "Proctor",
    noProctor: "No Proctor Assigned",
    noActiveRooms: "There are no active rooms right now.",
  },
  ExamBlock: {
    examCompleted: "This exam has been completed",
    bookingApproved: "Booking has been approved",
    notPresentForExam: "Not present for scheduled exam",
    bookingRejected: "Booking has been rejected",
    approvalTimeFrameMessage:
      "Your exam will be approved within 2 business days. You can expect to receive a notification, via email, upon approval.",
    reschedule: "Reschedule",
    cancel: "Cancel",
  },
  PastExams: {
    header: "Past Bookings",
    examTitle: "Exam Title",
    date: "Date & Time",
    timezone: "Timezone",
    status: "Status",
    noExams: "No past exams to display",
    cancelled: "Cancelled",
  },
  ClientDownload: {
    header: "Download Application",
    instructionsStepOne: "Select and download the application for your system",
    instructionsStepTwo: `Open the application and select the exam you are scheduled to write`,
    instructionsStepThree: `Follow the instructions as they are presented to reach
          eProctor Canada. Your login credentials for eProctor
          Canada and the exam provider's system (e.g. PSKN) are
          required`,
    systemRequirements: "Minimum System Requirements",
    networkRequirements: "Network Requirements",
    uploadSpeed: "Upload Speed",
    downloadSpeed: "Download Speed",
    minUploadSpeed: "2.5 Mbps Minimum",
    minDownloadSpeed: "2.5 Mbps Minimum",
    computerRequirements: "Computer Requirements",
    webcamWithMicrophone: "Webcam with microphone (or separate microphone)",
    windows: "Windows",
    minWindowsVersion: "Windows 10 or later",
    mac: "Mac",
    minMacVersion: "OS X 11 or later",
    downloadMessage: "Your download should begin automatically.",
    didntWork: "Didn’t work? Click <1>here</1> and try again",
    applicationDownload: "Application Download",
  },
  PendingRequests: {
    receiptEmailSubject: "eProctor Purchase Receipt - Booking Confirmed",
    bookingConfirmedEmail: "eProctor Booking Confirmed",
    bookingRejectedEmail: "eProctor Exam Request - Rejected",
    submittedDate: "Submitted Date",
    bookingDate: "Booking Date",
    downloadFile: "Download File",
    paymentError: "Payment Error",
  },
  RejectModal: {
    rejectBooking: "Reject Booking",
    rejectReasoning: "Reject Reasoning",
    chargedBookingWarningTitle: "User Has Already Been Charged",
    chargedBookingWarningBody:
      "This user has already been charged for this booking. Rejecting will issue a full refund to their card.",
  },
  RescheduleDates: {
    sendUserNotification:
      "Would you like to send the user a notification of the changes?",
  },
  Exam: {
    errorAddingHeader: "Error Adding Exam",
    daysAvailable: "Days Available",
    days: "Days",
    timesAvailable: "Times Available",
    capacity: "Capacity",
    cost: "Cost",
    addExam: "Add Exam",
    notApplicable: "Not Applicable",
    enableFileUpload: "Enable file upload (certificates)",
    checkinScript: "Proctor Rules / Check-in Script",
    studentRules: "Student Rules",
    uploadDescription: "Upload Description",
    from: "From",
    to: "To",
    limit: "Limit",
    examFrequency: "Exam Frequency",
  },
  ExamTable: {
    deleteExam: "Delete Exam",
    confirmDelete: "Are you sure you want to delete",
    confirmCancel: "Are you sure you want to cancel this booking?",
    learningInstitutions: "Learning Institution(s)",
    added: "Added",
    bookingLimit: "Booking Limit",
  },
  RescheduleExam: {
    header: "Reschedule Exam",
    resheduleEmailSubject: "eProctor Booking Rescheduled",
    dateAndTimeSlot: "Date and Time Slot",
    reschedule: "Reschedule",
    deleteBooking: "Delete Booking",
    confirmDelete: "Are you sure you want to delete this booking?",
    showFutureBookings: "Only show future bookings",
    cancelExam: "Cancel Exam",
    cancelWithRefund: "Cancel (With Refund)",
    cancelNoRefund: "Cancel (No Refund)",
    cancelExamWithRefundMsg: "Are you sure you want to cancel this booking? The user will receive a full refund.",
    cancelExamNoRefundMsg: "Are you sure you want to cancel this booking? No refund will be issued.",
    refunded: "Refunded",
    refundedYes: "Yes",
    refundedNo: "No",
  },
  Learners: {
    replays: "Replays",
    registeredOn: "Registered On",
    replays: "Replays",
    viewBookings: "View Bookings",
  },
  LearnerBookings: {
    bookingsFor: "Bookings for",
    recordings: "Recordings",
    confirmRequestRecordings: "Request the following recordings?",
    requestDownloadAgain: "Request Failed. Try Again?",
  },
  InstitutionsTable: {
    addInstitution: "Add Institution",
    institution: "Institution",
    addOrEditInstitution: "Add/Edit Institution",
    errorAddingClient: "Error Adding Client",
    institutionName: "Institution Name",
    pointOfContactName: "Point of Contact Name",
    pointOfContactEmail: "Point of Contact Email",
    availabilityStatus: "Availability Status",
    pointOfContact: "Point of Contact",
    contactEmail: "Contact Email",
    allowRescheduling: "Rescheduling / Cancellation",
    allowStudentsToRescheduleOrCancel: "Allow students to reschedule or cancel",
    allowReschedulingColumn: "Rescheduling Allowed",
  },
  BlockedDays: {
    header: "Blocked Days",
    addBlockedDay: "Add Blocked Day",
    confirmDelete: "Are you sure you want to delete this blocked day?",
    missingFieldsError: "Please fill out name and date.",
    everyYearLabel: "Date should be blocked every year",
    everyYear: "Every Year",
    allDay: "All Day",
    allDayLabel: "All Day?",
    times: "Time Slot to Block",
    overlapError:
      "Blocked Day Overlaps with existing blocked day/time slot for given exams.",
  },
  ExamSchedule: {
    createRoom: "Create Room",
  },
  ProctoringSession: {
    runningApplicationsWarningMessage: "User has banned application(s) running ",
    expandView: "Expanded View",
    cycleMaxUsers: "Cycle Max Users",
    faceToFaceDisconnected: "User has disconnected from face to face",
    faceToFaceConnected: "You are now connected",
    joinedSession: "Joined Session",
    noLearnersInExam: "No Current Learners in Exam",
    noLearnersInExamMessage: "We will let you know when someone joins.",
    monitorWarningMessage: "User has monitors: ",
    pushExamUrl: "Push Exam Url",
    url: "URL",
    pushExam: "Push Exam",
    pushExamAllUsers: "Push Exam To All Users",
    lostConnection: "Lost Connection",
    reJoinedSession: "Rejoined Session",
  },
  WebCamUser: {
    minimize: "Minimize",
    maximize: "Maximize",
    ban: "Ban",
    signOut: "Sign Out",
    flag: "Flag",
    singleLink: "Single Link",
    linkAll: "Link All",
    banUser: "Ban User",
    confirmBan: "Is it okay to ban",
    softBanUser: "Soft Boot User",
    confirmSoftBoot: "Is it okay to soft boot",
    callLearner: "Call Learner",
    userDisconnectedHeader: "Connection Lost",
    userDisconnectedMessage: "Attempting to restablish connection.",
    refresh: "Refresh",
    moveToRoom: "Move to Room",
  },
  Checkin: {
    learnerRejoinedHeader: "Learner Rejoined",
    learnerRejoinedMessage: "Learner has rejoined check in",
    learnerLeftHeader: "Learner Left",
    learnerLeftMessage: `The learner has left the check in area or is having Network
          Problems.`,
    webcamNotReadableHeader: "Webcam Not Readable",
    webcamNotReadableMessage: `Unable to access Proctors webcam. Please ensure webcam is not
          in use by another program.`,
    checkinScript: "Check-in Script",
    noRules: "No Rules For Exam.",
    userTyping: "is Typing...",
  },
  Chat: {
    proctor: "(Proctor)",
    typeMessageHere: "Type Message Here",
  },
  CheckinQueue: {
    header: "Check-in Queue",
    clientVersion: "Client Version",
    checkIn: "Check-in",
    noRoomsAvailable: "No Rooms Available",
    moveUser: "Move User",
    noUsersInRoom: "No users in this Room.",
    deleteRoom: "Delete Room",
  },
  CouponTable: {
    over100Error: "Coupon can not be over 100%.",
    addCoupon: "Add Coupon",
    addOrEditCoupon: "Add/Edit Coupon",
    missingFieldsErrorHeader: "Error Adding Coupon",
    couponCode: "Coupon Code",
    couponValue: "Coupon Value",
    couponValueType: "Coupon Value Type",
    valueType: "Value Type",
    selectExams: "Please Select Exams",
    maxUses: "Max Number of Uses",
    availabilityStatus: "Availability Status",
    value: "Value",
    exams: "Exam(s)",
    maxUses: "Max Uses",
    timesUsed: "Times Used",
    deactivateCoupon: "Deactivate Coupon",
    activateCoupon: "Activate Coupon",
    deactivateCouponConfirm: "Are you sure you want to deactivate this Coupon?",
    activateCouponConfirm: "Are you sure you want to activate this Coupon?",
  },
  JoinExamModal: {
    joinAnExam: "Join An Exam",
    join: "Join",
    leaveExam: "Leave Exam",
    joinExam: "Join Exam",
  },
  CreateRoom: {
    addRoom: "Add Room",
    title: "Title",
    roomTitle: "Room Title",
    dateAndTime: "Date & Time",
    submit: "Submit",
  },
  PictureUploader: {
    uploadFile: "Upload File",
    clickToUpload: "Click here to upload.",
    dragDropText: "or drag and drop your image here",
    imageLoaded: "Image loaded successfully",
    uploadButton: "Choose & Upload Image",
    fileRequirements: "PNG or JPEG, max 5MB",
    fileTooLargeError: "File must be 5MB or less.",
    incorrectFileTypeError: "File must be of type JPEG or PNG",
    text: "Click on box to upload personal Headshot",
  },
  Emails: {
    emailSubject: "Email Subject",
    supportCenter: "eProctor Support Centre",
    tollFree: "Toll Free",
    BookingApproval: {
      header: "Booking Confirmed for {{ examTitle }}",
      message: `Your exam on {{ bookingDate }} {{ timezone }} has been approved.
            Please pay close attention to the following:`,
      timezoneWarning: `Make sure your computer and your eProctor account time zone setting matches the time zone of your location. (For example, if you are in Alberta, your time zone should be Mountain Time.) You can verify or update this setting under your "Account Settings".`,
      preExamInstructions: `Prior to writing your exam, complete a
            <1>Speed Test</1> in the
            location you plan to write to ensure your internet speeds meet
            the
            <3>
              system requirements
            </3>
            of eProctor Canada.`,
      downloadLatestClient: `On the day of your exam download the latest version of the
            <1>
              eProctor Canada Application.
            </1>
            If you don’t have the latest version of the application, you
            won’t be able to access the exam.`,
      checkinTime: `30 minutes prior to the exam, login to the eProctor application to
            complete the validation and check-in process.`,
      lateWarning: `If you are more than 15 minutes late, you will not be allowed to
            write the exam.`,
      examDuration: "Exam Duration: {{duration}} hours",
      examRules: "Exam Specific Rules: {{ examRules }}",
    },
    BookingRejected: {
      header: "eProctor Booking Request - Rejected",
      invoiceNumber: `invoice #: {{invoiceNumber}}`,
      message: `Booking Request for {{ name }} to take {{ examTitle }}
            has been Rejected`,
      reason: "Reason Provided: {{ reason }}",
      refundNoticeTitle: "Refund Processing",
      refundNotice: "Your refund will be processed within 5-10 business days and will appear on the original payment method used for this booking.",
      noChargeTitle: "No Payment Collected",
      noChargeNotice: "This booking was rejected before any payment was collected. If a temporary hold was placed on your card, it has already been released - you should see it reversed within 5-10 business days, depending on your bank, and no charge will appear on your statement.",
      supportContact: `For more information please contact the eProctor Support Centre via
            email at support@eproctorcanada.com or by calling 1-844-595-2561.`,
    },
    BookingRequest: {
      header: "Booking Request for {{ examTitle }} Pending",
      bookingCode: "Booking Code: {{ code }}",
      approvalTimeFrame:
        "Please note, it can take up to 2 business days for an exam booking to be approved.",
      postApprovalInstructions: `Once your exam has been approved, you will receive an email
            notification with your confirmation of payment. If you have any
            questions please contact the eProctor Support Centre via email at
            support@eproctorcanada.com or by calling 1-844-595-2561.`,
    },
    BookingReschedule: {
      header: "Booking Reschedule Confirmed for {{examTitle}}",
      message: `{{ name }}, Your previously schedule exam has been rescheduled to
            {{ bookingDate }} {{ timezone }}. Please login to your eProctor
            account 30 minutes prior to the exam to complete the validation
            and check-in process.`,
      duration: "Exam Duration: {{duration}} hours",
      examRules: "Exam Specific Rules: {{ examRules }}",
      defaultRules:
        "In Addition to the above, please have the following ready:",
      ruleOne: `The student is expected to remain in the exam room until the
            completion of the exam. Washroom breaks are not permitted.`,
      ruleTwo: "Please ensure the exam area is quiet and free of distractions.",
      ruleThree: `No cellular telephones, including smart watches and or other
            electronic devises are permitted in the area at the time of the
            exam`,
      ruleFour: "Government issued photo ID",
    },
    EmailReminder: {
      header: "eProctor Exam Reminder - {{ examTitle }}",
      message: `This note is to remind you of your upcoming scheduled exam with
            eProctor.`,
      examDate: "{{ examTitle }} on {{ date }}",
      checkinInstructions: `You can start the check-in process up to 30 minutes prior to your
            scheduled exam start time. The following will be required at
            check-in:`,
      checkinRequirementOne: "Photo ID",
      loginCredentialsMessage:
        "Login credentials (username and password) for your host exam system (PSKN)",
    },
    PurchaseReceipt: {
      header: "eProctor - Thank you for your order.",
      invoiceNumber: "Invoice #",
      businessNumber: "Business #808349930RT0001",
    },
    UserRegistration: {
      welcome: "Welcome to eProctor",
      welcomeMessage: `Welcome to eProctor - Canada's top provider of online proctoring
        services. To schedule your exam please visit http://eproctorcanada.com.
        For more information or technical support please contact
        support@eproctorcanada.com or by calling 1-844-595-2561.`,
    },
    BookingCancelled: {
      subjectWithRefund: "Booking Cancelled - Refund Issued",
      subjectNoRefund: "Booking Cancelled",
      headerWithRefund: "Booking Cancelled - Refund Issued",
      headerNoRefund: "Booking Cancelled",
      messageWithRefund: "Your booking for {{ examTitle }} scheduled for {{ bookingDate }} {{ timezone }} has been successfully cancelled.",
      messageNoRefund: "Your booking for {{ examTitle }} scheduled for {{ bookingDate }} {{ timezone }} has been successfully cancelled.",
      cancellationDetails: "Cancellation Details",
      examName: "Exam Name",
      scheduledDate: "Scheduled Date & Time",
      duration: "Duration",
      refundStatus: "Refund Status",
      refundApproved: "Refund Approved",
      noRefund: "No Refund",
      refundAmount: "Refund Amount",
      refundNoticeTitle: "Refund Processing",
      refundNotice: "Your refund will be processed within 5-10 business days and will appear on the original payment method used for this booking.",
      noRefundTitle: "Cancellation Policy",
      noRefundNotice: "This cancellation occurred within 24 hours of your scheduled exam time. According to our cancellation policy, no refund will be issued for cancellations made within this timeframe.",
      noChargeMade: "No Charge Made",
      noChargeTitle: "No Payment Collected",
      noChargeNotice: "This booking was cancelled before any payment was collected. If a temporary hold was placed on your card, it has already been released - you should see it reversed within 5-10 business days, depending on your bank, and no charge will appear on your statement.",
      closingWithRefund: "We're sorry to see you cancel your exam. If you would like to book another exam in the future, please visit our website.",
      closingNoRefund: "We're sorry to see you cancel your exam. If you would like to book another exam in the future, please visit our website.",
      questions: "If you have any questions or concerns, please contact us.",
    },
  },
};

export default en;
